import Vue from "vue";
import Element from 'element-ui'
import VueI18n from 'vue-i18n'
import en from './lang/en'
import zhCn from './lang/zh-cn'

Vue.use(VueI18n)

const messages = {
  en: {
    ...en
  },
  zh: {
    ...zhCn
  }
}
const i18n = new VueI18n({
  locale: 'zh',
  messages
})
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
export default i18n